import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./StabilizationReflux.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function StabilizationReflux() {

    useEffect(() => {
    
      trackPageVisit("StabilizationReflux");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);


     

  const DEFAULT_VALVES = {
  FCV_2901: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2902: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2903: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2904: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2905: { mode: "Manual", opening: 0, sp: "", pv: "" },


};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("StabilizationReflux_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2901: { ...DEFAULT_VALVES.FCV_2901, ...parsed.FCV_2901 },
      FCV_2902: { ...DEFAULT_VALVES.FCV_2902, ...parsed.FCV_2902 },
      FCV_2903: { ...DEFAULT_VALVES.FCV_2903, ...parsed.FCV_2903 },
      FCV_2904: { ...DEFAULT_VALVES.FCV_2904, ...parsed.FCV_2904 },
      FCV_2905: { ...DEFAULT_VALVES.FCV_2905, ...parsed.FCV_2905 },


    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("StabilizationReflux_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides} = usePlantStore();
            const TT_28023 = transmitters.TT_28023 || 0;
            const FIC_28023 = transmitters.FIC_28023 || 0;
            const PT_28023 = transmitters.PT_28023 || 0;
            const TT_28013 = transmitters.TT_28013 || 0;
            const FIC_28013 = transmitters.FIC_28013 || 0;
            const PT_28013 = transmitters.PT_28013 || 0;
            const TT_2802 = transmitters.TT_2802 || 0;
            const FIC_2802 = transmitters.FIC_2802 || 0;
            const PT_2802 = transmitters.PT_2802 || 0;





            /* =========================================================
   STABILIZER OVERHEAD STREAM
========================================================= */

const StabilizerOverhead = JSON.parse(

  localStorage.getItem("STAB_OVERHEAD")

) || {

  Flow: 0,

  Temperature: 25,

  Pressure: 0,

  Composition: {

    Methane: 0,

    Ethane: 0,

    Propane: 0,

    iButane: 0,

    nButane: 0,

    H2S: 0,

    CO2: 0,

    Hydrogen: 0,

    PentanesPlus: 0,

    Water: 0

  }

};



console.log(StabilizerOverhead);










  const xv2901Open = !valves?.XV_2901;
  const xv2902Open = !valves?.XV_2902;
  const xv2903Open = !valves?.XV_2903;



  const FIC_2901 = FIC_2802;
  const PT_2901 = PT_2802;
  const TT_2901 = TT_2802;


  const FIC_2902 = FIC_28013;
  const PT_2902 = PT_28013;
  const TT_2902 = TT_28013;

  const TT_2903 = xv2901Open ? 27.564 : 22;    // ================= FRESH WATER SUPPLY TO E-304

  
  
  /* =========================================================
   E-302A/B
   STABILIZED NAPHTHA ↔ COOLING WATER COOLER
========================================================= */

const TT_2904 = processData.TT_2904;
const TT_2905 = processData.TT_2905;

const AtmosphericTemperature = 25;

/* =========================================================
   REFS
========================================================= */

const E302_intervalRef = useRef(null);
const E302_isMounted = useRef(false);

const E302_processRef = useRef({});

/* =========================================================
   KEEP LIVE VALUES UPDATED
========================================================= */

useEffect(() => {

  E302_processRef.current = {

    TT_2902,
    TT_2903,
    xv2901Open

  };

});

/* =========================================================
   E-302 COOLER
========================================================= */

useEffect(() => {

  if (E302_isMounted.current) return;

  E302_isMounted.current = true;

  console.log("✅ E-302 interval created");

  E302_intervalRef.current = setInterval(() => {

    const {

      TT_2902,
      TT_2903,
      xv2901Open

    } = E302_processRef.current;

    /* =====================================
       INLETS
    ===================================== */

    const hotInlet =
      Number(TT_2902) || 0;

    const waterInlet =
      Number(TT_2903) || AtmosphericTemperature;

    let targetTT2905 = hotInlet;
    let targetTT2904 = waterInlet;

    /* =====================================
       HEAT EXCHANGE
    ===================================== */

    if (

      xv2901Open &&
      hotInlet > waterInlet + 0.5

    ) {

      const deltaT =
        hotInlet - waterInlet;

      const effectiveness = 0.75;

      const hotLoss = Math.min(
        70,
        deltaT * effectiveness
      );

      const waterGain = Math.min(
        25,
        hotLoss * 0.35
      );

      targetTT2905 =
        hotInlet - hotLoss;

      targetTT2904 =
        waterInlet + waterGain;

      /* ===============================
         PHYSICAL LIMITS
      =============================== */

      targetTT2905 = Math.max(
        targetTT2905,
        waterInlet + 5
      );

      targetTT2904 = Math.min(
        targetTT2904,
        hotInlet - 5
      );

    }

    /* =====================================
       THERMAL LAG
    ===================================== */

    setProcessData(prev => ({

      ...prev,

      TT_2905: Number(

        (

          (prev.TT_2905 ?? hotInlet)

          +

          (

            targetTT2905 -

            (prev.TT_2905 ?? hotInlet)

          ) * 0.08

        ).toFixed(2)

      ),

      TT_2904: Number(

        (

          (prev.TT_2904 ?? waterInlet)

          +

          (

            targetTT2904 -

            (prev.TT_2904 ?? waterInlet)

          ) * 0.08

        ).toFixed(2)

      )

    }));

  }, 1000);

  return () => {

    console.log("❌ E-302 interval cleared");

    if (E302_intervalRef.current) {

      clearInterval(E302_intervalRef.current);

      E302_intervalRef.current = null;

    }

    E302_isMounted.current = false;

  };

}, []);




const FIC_2905 = FIC_2901;
const PT_2905 = PT_2901 * 0.67;

const FIC_2909 = flowOverrides?.FIC_2909 ? 0 : (1.2 * (valveData?.FCV_2905?.opening || 0)/100);
const PT_2909 = (valveData?.FCV_2905?.opening || 0)/100 > 0 ? 0.965 : 0.03;
const TT_2909 = (valveData?.FCV_2905?.opening || 0)/100 > 0 ? TT_2907 : 25;





/* =========================================================
   LPG REFLUX DRUM MIXER
   MIXING OF:
   - COOLED OVERHEAD (FIC_2905)
   - HOT OVERHEAD BYPASS (FIC_2901)
========================================================= */

const TT_2907 = processData.TT_2907;

/* =========================================================
   REFS
========================================================= */

const Mixer_intervalRef =
  useRef(null);

const Mixer_isMounted =
  useRef(false);

const TT_2907_Ref =
  useRef(
    processData.TT_2907 ?? TT_2905
  );

const Mixer_processRef =
  useRef({});

/* =========================================================
   KEEP VALUES UPDATED
========================================================= */

useEffect(() => {

  Mixer_processRef.current = {

    FIC_2901,
    TT_2901,
    PT_2901,

    FIC_2905,
    TT_2905,
    PT_2905,

    StabilizerOverhead

  };

});

/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  TT_2907_Ref.current =
    TT_2907 ?? TT_2905;

}, [TT_2907]);

/* =========================================================
   LPG REFLUX DRUM MIXER
========================================================= */

useEffect(() => {

  if (Mixer_isMounted.current)
    return;

  Mixer_isMounted.current = true;

  console.log(
    "✅ LPG Reflux Drum Mixer Started"
  );

  Mixer_intervalRef.current =
    setInterval(() => {

      const {

        FIC_2901,
        TT_2901,
        PT_2901,

        FIC_2905,
        TT_2905,
        PT_2905,

        StabilizerOverhead

      } = Mixer_processRef.current;

      /* ==========================================
         FLOWS
      ========================================== */

      const cooledFlow =
        Number(FIC_2905 || 0);

      const bypassFlow =
        Number(FIC_2901 || 0);

      const totalFlow =
        cooledFlow +
        bypassFlow;

      /* ==========================================
         MIXED TEMPERATURE
      ========================================== */

      let targetTT2907 = TT_2905;

      if (totalFlow > 0) {

        targetTT2907 =

          (

            (cooledFlow * TT_2905)

            +

            (bypassFlow * TT_2901)

          )

          /

          totalFlow;

      }

      /* ==========================================
         THERMAL LAG
      ========================================== */

      TT_2907_Ref.current +=

        (

          targetTT2907 -

          TT_2907_Ref.current

        ) * 0.12;

      /* ==========================================
         SAVE MIXED STREAM
      ========================================== */

      const MixedStream = {

        Flow: totalFlow,

        Temperature: Number(
          TT_2907_Ref.current.toFixed(2)
        ),

        Pressure: Math.min(
          Number(PT_2901 || 0),
          Number(PT_2905 || 0)
        ),

        Composition:
          StabilizerOverhead.Composition

      };

      localStorage.setItem(

        "LPG_REFLUX_MIXED",

        JSON.stringify(MixedStream)

      );

      /* ==========================================
         UPDATE PROCESS DATA
      ========================================== */

      setProcessData(prev => ({

        ...prev,

        TT_2907: Number(
          TT_2907_Ref.current.toFixed(2)
        )

      }));

    }, 1000);

  return () => {

    console.log(
      "❌ LPG Reflux Drum Mixer Stopped"
    );

    if (Mixer_intervalRef.current) {

      clearInterval(
        Mixer_intervalRef.current
      );

      Mixer_intervalRef.current =
        null;

    }

    Mixer_isMounted.current =
      false;

  };

}, []);





/* =========================================================
   LPG REFLUX DRUM
   THREE PHASE SEPARATOR
   PART A
========================================================= */

const FIC_2906 = processData.FIC_2906*(valveData?.FCV_2903?.opening || 0)/100;
const FIC_2907 = processData.FIC_2907;
const FIC_2908 = processData.FIC_2908;

const PT_2906 = (valveData?.FCV_2903?.opening || 0)/100 > 0 ? processData.PT_2906 : 0.03;
const TT_2906 = (valveData?.FCV_2903?.opening || 0)/100 > 0 ? processData.TT_2906 : 25;

/* =========================================================
   REFS
========================================================= */

const Separator_intervalRef =
  useRef(null);

const Separator_isMounted =
  useRef(false);

const FIC_2906_Ref =
  useRef(processData.FIC_2906 ?? 0);

const FIC_2907_Ref =
  useRef(processData.FIC_2907 ?? 0);

const FIC_2908_Ref =
  useRef(processData.FIC_2908 ?? 0);

const TT_2906_Ref =
  useRef(processData.TT_2906 ?? 35);

const PT_2906_Ref =
  useRef(processData.PT_2906 ?? 0.8);

/* =========================================================
   KEEP REFS UPDATED
========================================================= */

useEffect(() => {

  FIC_2906_Ref.current =
    FIC_2906 ?? 0;

}, [FIC_2906]);

useEffect(() => {

  FIC_2907_Ref.current =
    FIC_2907 ?? 0;

}, [FIC_2907]);

useEffect(() => {

  FIC_2908_Ref.current =
    FIC_2908 ?? 0;

}, [FIC_2908]);

useEffect(() => {

  TT_2906_Ref.current =
    TT_2906 ?? 35;

}, [TT_2906]);

useEffect(() => {

  PT_2906_Ref.current =
    PT_2906 ?? 0.8;

}, [PT_2906]);

/* =========================================================
   SEPARATOR
========================================================= */

useEffect(() => {

if (Separator_isMounted.current)
return;

Separator_isMounted.current = true;

console.log(
"✅ LPG Separator Started"
);

Separator_intervalRef.current =
setInterval(() => {

const MixedStream =
JSON.parse(

localStorage.getItem(
"LPG_REFLUX_MIXED"
)

);

if(!MixedStream)
return;

const {

Flow,

Temperature,

Pressure,

Composition

} = MixedStream;

/* ==========================================
   PROPANE SPLIT
========================================== */

let propaneToLPG = 0.80;

if(Temperature <= 35){

propaneToLPG = 0.90;

}

else if(Temperature <=45){

propaneToLPG = 0.75;

}

else if(Temperature <=55){

propaneToLPG = 0.60;

}

else if(Temperature <=65){

propaneToLPG = 0.45;

}

else{

propaneToLPG = 0.30;

}

/* ==========================================
   DRY GAS
========================================== */

const DryGas = {

Methane:
Composition.Methane,

Ethane:
Composition.Ethane * 0.95,

Propane:
Composition.Propane *
(1-propaneToLPG),

iButane:
Composition.iButane * 0.05,

nButane:
Composition.nButane * 0.02,

Hydrogen:
Composition.Hydrogen,

H2S:
Composition.H2S * 0.90,

CO2:
Composition.CO2 * 0.98,

PentanesPlus:
0,

Water:
0

};

/* ==========================================
   LPG PRODUCT
========================================== */

const LPG = {

Methane:
0,

Ethane:
Composition.Ethane * 0.05,

Propane:
Composition.Propane *
propaneToLPG,

iButane:
Composition.iButane * 0.95,

nButane:
Composition.nButane * 0.98,

Hydrogen:
0,

H2S:
Composition.H2S * 0.05,

CO2:
Composition.CO2 * 0.02,

PentanesPlus:
Composition.PentanesPlus,

Water:
Composition.Water * 0.02

};

/* ==========================================
   WATER
========================================== */

const Water = {

Methane:0,

Ethane:0,

Propane:0,

iButane:0,

nButane:0,

Hydrogen:0,

CO2:0,

PentanesPlus:0,

H2S:
Composition.H2S * 0.05,

Water:
Composition.Water * 0.98

};

/* ==========================================
   CALCULATE TOTAL FLOWS
========================================== */

const DryGasFlow =

Object.values(DryGas)
.reduce((a,b)=>a+b,0);

const LPGFlow =

Object.values(LPG)
.reduce((a,b)=>a+b,0);

const WaterFlow =

Object.values(Water)
.reduce((a,b)=>a+b,0);





/* ==========================================
   PROCESS LAG
========================================== */

FIC_2906_Ref.current +=
(
  DryGasFlow -
  FIC_2906_Ref.current
) * 0.12;

FIC_2907_Ref.current +=
(
  LPGFlow -
  FIC_2907_Ref.current
) * 0.12;

FIC_2908_Ref.current +=
(
  WaterFlow -
  FIC_2908_Ref.current
) * 0.08;

/* ==========================================
   DRY GAS CONDITIONS
========================================== */

/*
Dry gas leaves slightly warmer than
the liquid because the liquid
evaporation cools the drum.
*/

const targetTT2906 =
Math.max(
  28,
  Temperature - 5
);

TT_2906_Ref.current +=
(
  targetTT2906 -
  TT_2906_Ref.current
) * 0.10;

/*
Very small pressure drop
across the separator.
*/

const targetPT2906 =
Math.max(
  0,
  Pressure - 0.02
);

PT_2906_Ref.current +=
(
  targetPT2906 -
  PT_2906_Ref.current
) * 0.10;

/* ==========================================
   SAVE DRY GAS STREAM
========================================== */

localStorage.setItem(

"LPG_DRY_GAS",

JSON.stringify({

Flow:
Number(
FIC_2906_Ref.current.toFixed(4)
),

Temperature:
Number(
TT_2906_Ref.current.toFixed(2)
),

Pressure:
Number(
PT_2906_Ref.current.toFixed(3)
),

Composition:
DryGas

})

);

/* ==========================================
   SAVE LPG STREAM
========================================== */

localStorage.setItem(

"LPG_PRODUCT",

JSON.stringify({

Flow:
Number(
FIC_2907_Ref.current.toFixed(4)
),

Temperature:
Number(
Temperature.toFixed(2)
),

Pressure:
Number(
Pressure.toFixed(3)
),

Composition:
LPG

})

);

/* ==========================================
   SAVE WATER STREAM
========================================== */

localStorage.setItem(

"LPG_WATER",

JSON.stringify({

Flow:
Number(
FIC_2908_Ref.current.toFixed(4)
),

Temperature:
Number(
Temperature.toFixed(2)
),

Pressure:
Number(
Pressure.toFixed(3)
),

Composition:
Water

})

);

/* ==========================================
   UPDATE PROCESS DATA
========================================== */

setProcessData(prev => ({

...prev,

FIC_2906:
Number(
FIC_2906_Ref.current.toFixed(4)
),

FIC_2907:
Number(
FIC_2907_Ref.current.toFixed(4)
),

FIC_2908:
Number(
FIC_2908_Ref.current.toFixed(4)
),

TT_2906:
Number(
TT_2906_Ref.current.toFixed(2)
),

PT_2906:
Number(
PT_2906_Ref.current.toFixed(3)
)

}));

},1000);

return ()=>{

console.log(
"❌ LPG Separator Stopped"
);

if(
Separator_intervalRef.current
){

clearInterval(
Separator_intervalRef.current
);

Separator_intervalRef.current =
null;

}

Separator_isMounted.current =
false;

};

},[]);





/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-302A / B STATUS
========================================================= */

const P302A_Running =
pumpData?.["P-302A"]?.running ?? false;

const P302B_Running =
pumpData?.["P-302B"]?.running ?? false;

const P302_Running =
P302A_Running || P302B_Running;


/* =========================================================
   SUCTION VALVE
========================================================= */

const suctionAvailable =
xv2902Open === true;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P302_CAPACITY = 0.23;


/* =========================================================
   CONTROL VALVES
========================================================= */

const FCV2901_Opening =
(valveData?.FCV_2901?.opening || 0)/100;

const FCV2904_Opening =
(valveData?.FCV_2904?.opening || 0)/100;


/* =========================================================
   TOTAL OPENING
========================================================= */

const totalOpening =
FCV2901_Opening +
FCV2904_Opening;


/* =========================================================
   AVAILABLE FLOW
========================================================= */

const availableFlow =
(
P302_Running &&
suctionAvailable
)
?
P302_CAPACITY *
Math.min(totalOpening,1)
:
0;


/* =========================================================
   TARGET FLOWS
========================================================= */

const targetFIC29010 =
totalOpening>0
?
availableFlow*
(
FCV2901_Opening/
totalOpening
)
:
0;


const targetFIC29011 =
totalOpening>0
?
availableFlow*
(
FCV2904_Opening/
totalOpening
)
:
0;



/* =========================================================
   P-302A/B PUMP ENGINE
========================================================= */

useEffect(() => {

const timer = setInterval(() => {

setProcessData(prev => {

const currentFlow1 =
Number(prev.FIC_29010 || 0);

const currentFlow2 =
Number(prev.FIC_29011 || 0);

const currentPressure =
Number(prev.PT_29010 || 0.03);

const currentTemp =
Number(prev.TT_29010 || TT_2907);


/* ==========================================
   TARGETS
========================================== */

let targetFlow1 = 0;
let targetFlow2 = 0;

let targetPressure = 0.03;
let targetTemp = 32;


/* ==========================================
   PUMP RUNNING
========================================== */

if (
P302_Running &&
suctionAvailable
){

targetFlow1 = targetFIC29010;
targetFlow2 = targetFIC29011;

const totalFlow =
targetFlow1 +
targetFlow2;

const flowFraction =
totalFlow /
P302_CAPACITY;


/* ==========================================
   PRESSURE
========================================== */

if(
FCV2901_Opening <= 0 &&
FCV2904_Opening <= 0
){

// True dead-head

targetPressure = 2.60;

}
else if(flowFraction < 0.20){

const restriction =
(0.20-flowFraction)/0.20;

targetPressure =
1.80 +
restriction*0.80;

}
else{

targetPressure =
1.80 -
(flowFraction-0.20)*0.25;

}


/* ==========================================
   TEMPERATURE
========================================== */

targetTemp =
Number(TT_2907)+0.5;


// Dead-head heating

if(totalFlow<=0){

targetTemp =
Number(TT_2907)+8;

}


// High restriction heating

else if(flowFraction<0.20){

const restriction =
(0.20-flowFraction)/0.20;

targetTemp =
Number(TT_2907)+
0.5+
restriction*4;

}

}


/* ==========================================
   UPDATE ALL TOGETHER
========================================== */

return{

...prev,

FIC_29010:
Number(
(
currentFlow1+
(targetFlow1-currentFlow1)*0.12
).toFixed(3)
),

FIC_29011:
Number(
(
currentFlow2+
(targetFlow2-currentFlow2)*0.12
).toFixed(3)
),

PT_29010:
Number(
(
currentPressure+
(targetPressure-currentPressure)*0.08
).toFixed(3)
),

TT_29010:
Number(
(
currentTemp+
(targetTemp-currentTemp)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P302_Running,
suctionAvailable,
FCV2901_Opening,
FCV2904_Opening,
TT_2907,
targetFIC29010,
targetFIC29011
]);



/* =========================================================
   P-302 TRANSMITTERS
========================================================= */

const FIC_29010 = flowOverrides?.FIC_29010 ? 0 :
(Number(
processData.FIC_29010 || 0
));

const FIC_29011 = flowOverrides?.FIC_29011 ? 0 :
Number(
processData.FIC_29011 || 0
);

const FIC_29005 =
Number(
(
FIC_29010 +
FIC_29011
).toFixed(3)
);

const PT_29010 =
Number(
processData.PT_29010 || 0.03
);

const TT_29010 =
Number(
processData.TT_29010 || TT_2907
);


const FIC_29012 = FIC_2906 * (valveData?.FCV_2902?.opening || 0)/100;

const TT_29011 = (valveData?.FCV_2904?.opening || 0)/100 > 0 ? TT_29010 : 25;
const PT_29011 = (valveData?.FCV_2904?.opening || 0)/100 > 0 ? PT_29010 : 0.03;


    const FIC_29013 = xv2903Open ? 3.0495 : 0;










useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_2906 === TT_2906 &&
    current.FIC_2906 === FIC_2906 &&
    current.PT_2906 === PT_2906 &&
    current.TT_29010 === TT_29010 &&
    current.FIC_29010 === FIC_29010 &&
    current.PT_29010 === PT_29010 &&
    current.TT_29011 === TT_29011 &&
    current.FIC_29011 === FIC_29011 &&
    current.PT_29011 === PT_29011 &&
    current.FIC_29012 === FIC_29012 &&
    current.TT_2909 === TT_2909 &&
    current.FIC_2909 === FIC_2909 &&
    current.PT_2909 === PT_2909
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_2906, FIC_2906, PT_2906, TT_29010, FIC_29010, PT_29010, TT_29011, FIC_29011, PT_29011, TT_2909, FIC_2909, PT_2909, FIC_29012
    }
  });

}, [TT_2906, FIC_2906, PT_2906, TT_29010, FIC_29010, PT_29010, TT_29011, FIC_29011, PT_29011, TT_2909, FIC_2909, PT_2909, FIC_29012]);







  return (
    <div className="StabilizationReflux-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "5px",
          left: "220px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 256px",
          zIndex: 10,
        }}
      >
        STABILIZER REFLUX SYSTEM
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

    {/* XV-2901 */}
      <Valve
        className="XV-2901"
        tag="XV_2901"
        x={221}
        y={544}
        isClosed={valves.XV_2901}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2902 */}
      <Valve
        className="XV-2902"
        tag="XV_2902"
        x={735}
        y={420}
        isClosed={valves.XV_2902}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-2903 */}
      <Valve
        className="XV-2903"
        tag="XV_2903"
        x={1035}
        y={185}
        isClosed={valves.XV_2903}
        toggle={toggleValve}
      />

      

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2901 */}
        <div
            style={{ position: "absolute", left: 1000, top: 596}}
            onMouseEnter={() => setHoveredValve("FCV_2901")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2901")}
          >

            {hoveredValve === "FCV_2901" && (
              <div style={tagStyle}>
                FCV_2901
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2901">
                    
          <defs>
            <linearGradient id="metal_2901">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2901)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2901)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2902 */}
        <div
            style={{ position: "absolute", left: 1070, top: 144}}
            onMouseEnter={() => setHoveredValve("FCV_2902")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2902")}
          >

            {hoveredValve === "FCV_2902" && (
              <div style={tagStyle}>
                FCV_2902
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2902">
                    
          <defs>
            <linearGradient id="metal_2902">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2902)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2902)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2903 */}
        <div
            style={{ position: "absolute", left: 1000, top: 73}}
            onMouseEnter={() => setHoveredValve("FCV_2903")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2903")}
          >

            {hoveredValve === "FCV_2903" && (
              <div style={tagStyle}>
                FCV_2903
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2903">
                    
          <defs>
            <linearGradient id="metal_2903">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2903)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2903)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2904 */}
        <div
            style={{ position: "absolute", left: 1000, top: 686}}
            onMouseEnter={() => setHoveredValve("FCV_2904")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2904")}
          >

            {hoveredValve === "FCV_2904" && (
              <div style={tagStyle}>
                FCV_2904
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2904">
                    
          <defs>
            <linearGradient id="metal_2904">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2904)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2904)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2905 */}
        <div
            style={{ position: "absolute", left: 1000, top: 404}}
            onMouseEnter={() => setHoveredValve("FCV_2905")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2905")}
          >

            {hoveredValve === "FCV_2905" && (
              <div style={tagStyle}>
                FCV_2905
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2905">
                    
          <defs>
            <linearGradient id="metal_2905">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2905)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2905)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 290 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 290 + index * 40
              }}
            />
          ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2901?.opening || 0)}
        x={1022}
        y={641}
      />


      <ValveOutput
        value={Number(valveData?.FCV_2902?.opening || 0)}
        x={1092}
        y={192}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2903?.opening || 0)}
        x={1021}
        y={119}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2904?.opening || 0)}
        x={1022}
        y={731}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2905?.opening || 0)}
        x={1022}
        y={451}
      />






      <Transmitter
        tag="FIC_2901"
        value={[FIC_2901]}
        x={135}
        y={137}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM E-304A/B TO E-303 A/B AT STABILIZER REFULX SYSTEM"
      />


      <Transmitter
        tag="PT_2901"
        value={[PT_2901]}
        x={235}
        y={137}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM E-304A/B TO E-303 A/B AT STABILIZER REFULX SYSTEM"
      />


      <Transmitter
        tag="TT_2901"
        value={[TT_2901]}
        x={345}
        y={137}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM E-304A/B TO E-303 A/B AT STABILIZER REFULX SYSTEM"
      />

      <Transmitter
        tag="FIC_2902"
        value={[FIC_2902]}
        x={175}
        y={73}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA VAPOR OVERHEAD BYPASS LINE OF STABILIZER TOWER (T-301) TO V-302"
      />


      <Transmitter
        tag="PT_2902"
        value={[PT_2902]}
        x={335}
        y={73}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA VAPOR OVERHEAD BYPASS LINE OF STABILIZER TOWER (T-301) TO V-302"
      />


      <Transmitter
        tag="TT_2902"
        value={[TT_2902]}
        x={545}
        y={73}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA VAPOR OVERHEAD BYPASS LINE OF STABILIZER TOWER (T-301) TO V-302"
      />

      <Transmitter
        tag="TT_2903"
        value={[TT_2903]}
        x={145}
        y={597}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER SUPPLY TO E-304A/B"
      />

      <Transmitter
        tag="TT_2904"
        value={[TT_2904]}
        x={145}
        y={192}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF FRESH WATER RETURN FROM E-304A/B TO WATER HEADER"
      />

      <Transmitter
        tag="TT_2905"
        value={[TT_2905]}
        x={366}
        y={557}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF NAPHTHA FROM E-303A/B TO STABILIZER REFULX DRUM (V-302)"
      />

      <Transmitter
        tag="FIC_2905"
        value={[FIC_2905]}
        x={535}
        y={447}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF NAPHTHA FROM E-303A/B TO STABILIZER REFULX DRUM (V-302)"
      />


      <Transmitter
        tag="PT_2905"
        value={[PT_2905]}
        x={535}
        y={407}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF NAPHTHA FROM E-303A/B TO STABILIZER REFULX DRUM (V-302)"
      />

      <Transmitter
        tag="TT_2906"
        value={[TT_2906]}
        x={1106}
        y={73}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DRY GAS OUTLET FROM STABILIZER REFULX DRUM (V-302) TO V-504"
      />

      <Transmitter
        tag="FIC_2906"
        value={[FIC_2906]}
        x={935}
        y={73}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DRY GAS OUTLET FROM STABILIZER REFULX DRUM (V-302) TO V-504"
      />


      <Transmitter
        tag="PT_2906"
        value={[PT_2906]}
        x={1235}
        y={57}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DRY GAS OUTLET FROM STABILIZER REFULX DRUM (V-302) TO V-504"
      />

      <Transmitter
        tag="TT_2907"
        value={[TT_2907]}
        x={816}
        y={191}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF STABILIZER REFULX DRUM (V-302)"
      />

      <Transmitter
        tag="TT_2909"
        value={[TT_2909]}
        x={1106}
        y={398}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF PRODUCED WATER OUTLET FROM STABILIZER REFULX DRUM (V-302) TO WASTE WATER MANAGEMENT SYSTEM (SEWAGE V-101)"
      />

      <Transmitter
        tag="FIC_2909"
        value={[FIC_2909]}
        x={885}
        y={398}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF PRODUCED WATER OUTLET FROM STABILIZER REFULX DRUM (V-302) TO WASTE WATER MANAGEMENT SYSTEM (SEWAGE V-101)"
      />


      <Transmitter
        tag="PT_2909"
        value={[PT_2909]}
        x={1235}
        y={373}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF PRODUCED WATER OUTLET FROM STABILIZER REFULX DRUM (V-302) TO WASTE WATER MANAGEMENT SYSTEM (SEWAGE V-101)"
      />

      <Transmitter
        tag="TT_29010"
        value={[TT_29010]}
        x={895}
        y={593}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF PRODUCED LPG OUTLET FROM STABILIZER REFULX DRUM (V-302) THROUGH P-302A/B"
      />

      <Transmitter
        tag="FIC_29010"
        value={[FIC_29010]}
        x={1105}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF PRODUCED LPG OUTLET FROM STABILIZER REFULX DRUM (V-302) THROUGH P-302A/B FOR REFLUXING AT STABILIZER TOWER OVERHEAD"
      />
      <Transmitter
        tag="FIC_29011"
        value={[FIC_29011]}
        x={1105}
        y={684}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF PRODUCED LPG OUTLET FROM STABILIZER REFULX DRUM (V-302) THROUGH P-302A/B TO LPG STORAGE V-514"
      />

      <Transmitter
        tag="FIC_29012"
        value={[FIC_29012]}
        x={1145}
        y={140}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DRY GAS OUTLET FROM STABILIZER REFULX DRUM (V-302) THROUGH PSV TO FLARE HEADER"
      />


      <Transmitter
        tag="PT_29010"
        value={[PT_29010]}
        x={685}
        y={623}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF PRODUCED LPG OUTLET FROM STABILIZER REFULX DRUM (V-302) THROUGH P-302A/B"
      />





          <LevelTransmitterIndicator
              tag="LT_2901"
              totalLevel={50}
              inflows={[FIC_2907+FIC_29013]}
              outflows={[FIC_29010 + FIC_29011]}
              inflowTags={["FIC_2907", "FIC_29013"]}
              outflowTags={["FIC_29010", "FIC_29011"]}
              responseFactor={0.05}
              columnX={703}
              columnY={237}
              columnWidth={278}
              columnHeight={100}
              textX={590}
              textY={240}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.8}
              service="lpg"
            />

          <LevelTransmitterIndicator
              tag="LT_2902"
              totalLevel={50}
              inflows={[FIC_2908]}
              outflows={[FIC_2909]}
              inflowTags={["FIC_2908"]}
              outflowTags={["FIC_2909"]}
              responseFactor={0.05}
              columnX={703}
              columnY={237}
              columnWidth={278}
              columnHeight={100}
              textX={1010}
              textY={240}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.2}
              service="water"
            />



            <Pump
              tag="P-302A"
              x={607}
              y={591}
              rpm={1800}
              bladeCount={pumpData?.["P-302A"]?.bladeCount || 3}
              size={pumpData?.["P-302A"]?.size || 40}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-302B"
              x={607}
              y={665}
              rpm={1800}
              bladeCount={pumpData?.["P-302B"]?.bladeCount || 3}
              size={pumpData?.["P-302B"]?.size || 40}
              onClick={openPumpPanel}
            />







    </div>
  );
}

export default StabilizationReflux;